

































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import http from '@/utils/http'

@Component({
  components: {
  }
})
export default class Signup extends Vue {

  private errorMessage = ''
  private name = ''
  private organizationNumber = ''
  private email = ''
  private password1 = ''
  private password2 = ''
  private showPassword1 = false
  private showPassword2 = false
  private isDone = false
  private showPrivacyAlert = true
  private acceptPrivacyTerms = false
  private showPrivacyTerms = false

  public signup() {

    if (!this.acceptPrivacyTerms) {
      this.setError('Du må godta villkårene for personvern')
      return
    }

    const required = [
      'name',
      'organizationNumber',
      'email',
      'password1',
      'password2'
    ]
    const labels = {
      name: 'Navn',
      organizationNumber: 'Org.nr.',
      email: 'E-post',
      password1: 'Passord',
      password2: 'Passord (gjenta)'
    }
    for (const field of required) {
      // @ts-ignore
      const value: any = (this[field] || '').trim()
      if (!value) {
        // @ts-ignore
        const label = labels[field]
        this.setError('Feltet "' + label + '" er påkrevd')
        return
      }
    }
    if (this.password1 !== this.password2) {
      this.setError('Passordene må være like')
      return
    }
    const match = this.organizationNumber.match(/^([a-z]{2})?(\d+)$/)
    const invalidOrgNumberError = 'Ugyldig org.nr, må være 9 siffer (uten mellomrom og lign.), eller på internasjonalt format'
    let orgNumber = ''
    if (match) {
      const country = match[1] ? match[1].toUpperCase() : 'NO'
      const number = match[2]
      if (country === 'NO') {
        if (number.length !== 9) {
          this.setError(invalidOrgNumberError)
          return
        }
      } else {
        if (number.length < 6) {
          this.setError(invalidOrgNumberError)
          return
        }
      }
      orgNumber = country + number
    } else {
      this.setError(invalidOrgNumberError)
      return
    }
    const data = {
      name: this.name,
      organizationId: orgNumber,
      email: this.email,
      password: this.password1
    }
    http.post('/auth/signup', data)
      .then((response: any) => {
        this.isDone = true
      })
      .catch((err: any) => {
        const message = err.response && err.response.data && err.response.data.errorMessage
          ? err.response.data.errorMessage
          : 'Error communicating with backend (' + err + ')'
        this.setError(message)
      })
  }

  public gotoLogin() {
    this.$router.push('login')
  }

  private setError(msg: string) {
    this.errorMessage = msg
  }

}
